<template>
  <b-card>
    <div>
      <Strong>Rider-Wise Performance Report</Strong>

      <b-row class="mt-4">
        <b-col >                    
          <div>
            <ul class="nav nav-tabs nav-justified">
              <li class="nav-item">
                <a @click="activeTab = 1;" class="nav-link" :class="{'active' : isActiveTab(1)}" >OFD Report</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 2;" class="nav-link " :class="{'active' : isActiveTab(2)}">OFP Report</a>
              </li>            
            </ul>
          </div>                       
        </b-col>
      </b-row>

      <component :is="currentComponent" class="mt-4"></component>
    </div>
  </b-card>
</template>
  
<script>
import riderWiseOFDReport from './riderWiseOFDReport.vue';
import riderWiseOFPReport from './riderWiseOFPReport.vue';
  export default {
    components: {
      riderWiseOFDReport,
      riderWiseOFPReport
    },
    data: function(){
      return{
        activeTab: 1,
        name: 'riderWisePerformanceReport',
      }
    },
    computed: {
      currentComponent(){
        if(this.activeTab === 1)           
          return "riderWiseOFDReport";
        else
          return "riderWiseOFPReport";
      }
    },
    created: function(){
      this.isActiveTab(1);
    },
    methods:{
      isActiveTab(id)
      {
        return this.activeTab === id;
      }
    }
  };
</script>

<style>

</style>